import { ComponentProps } from 'react';

export const IconSearch_26 = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5206 13.5906L16.8071 15.8771C17.0643 16.1343 17.0643 16.5501 16.8071 16.8073C16.6788 16.9355 16.5105 17 16.342 17C16.1736 17 16.0052 16.9355 15.877 16.8073L13.5905 14.5207L14.5206 13.5906ZM13.6568 12.6097C14.4953 11.5457 14.998 10.2058 14.998 8.74909C14.998 5.30355 12.1945 2.5 8.74899 2.5C5.30348 2.5 2.5 5.30352 2.5 8.74906C2.5 12.1946 5.30351 14.9982 8.74902 14.9982C10.1255 14.9982 11.3977 14.5493 12.4313 13.7924L12.4303 13.7916C12.4303 13.7916 12.9118 13.3979 13.1773 13.1325C13.4223 12.8874 13.6269 12.6454 13.6568 12.6097ZM3.81559 8.74906C3.81559 11.4697 6.02839 13.6826 8.74902 13.6826C11.4696 13.6826 13.6824 11.4697 13.6824 8.74906C13.6824 6.0284 11.4697 3.81558 8.74902 3.81558C6.02839 3.81558 3.81559 6.0284 3.81559 8.74906Z"
        fill="currentColor"
      />
    </svg>
  );
};
